var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6663 5.33335C18.6663 3.86059 17.4724 2.66669 15.9997 2.66669C14.5269 2.66669 13.333 3.86059 13.333 5.33335H6.66634C5.92996 5.33335 5.33301 5.93031 5.33301 6.66669C5.33301 7.40307 5.92996 8.00002 6.66634 8.00002H25.333C26.0694 8.00002 26.6663 7.40307 26.6663 6.66669C26.6663 5.93031 26.0694 5.33335 25.333 5.33335H18.6663Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6663 17.3334C14.6663 16.597 14.0694 16 13.333 16C12.5966 16 11.9997 16.597 11.9997 17.3334V22.6667C11.9997 23.4031 12.5966 24 13.333 24C14.0694 24 14.6663 23.4031 14.6663 22.6667V17.3334Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9997 17.3334C19.9997 16.597 19.4027 16 18.6663 16C17.93 16 17.333 16.597 17.333 17.3334V22.6667C17.333 23.4031 17.93 24 18.6663 24C19.4027 24 19.9997 23.4031 19.9997 22.6667V17.3334Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99967 10.6667C6.52692 10.6667 5.33301 11.8606 5.33301 13.3334V26.6667C5.33301 28.1394 6.52692 29.3334 7.99967 29.3334H23.9997C25.4724 29.3334 26.6663 28.1394 26.6663 26.6667V13.3334C26.6663 11.8606 25.4724 10.6667 23.9997 10.6667H7.99967ZM7.99967 13.3334V26.6667H23.9997V13.3334H7.99967Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.6f16ec8671b42730f416489b14f75215.svg";
export { ForwardRef as ReactComponent };